import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData/appDataSlice";
import "./SnippetSidebarMenu.css";
import "../../css/Icons.css";
import { LinkRecord, Snippet } from "winslow-core";
import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";
import { NEW_SNIPPET_ID } from "../ai/AISidebarAsk";

const SNIPPET_MENU = {
  DUPLICATE: "duplicate",
};

type SnippetSidebarMenuProps = {
  snippet: Snippet;
  onDuplicate: () => void;
};

export default function SnippetSidebarMenu({
  snippet,
  onDuplicate,
}: SnippetSidebarMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeUser = useSelector(selectUser);

  const nonFilelinkRecords: LinkRecord[] | undefined =
    snippet?.linkRecords.filter((linkRecord: LinkRecord) => {
      if (linkRecord.links && linkRecord.links.length > 0) {
        return linkRecord.links[0].appId !== "FILE";
      }

      if (linkRecord.source === "LINK") {
        return true;
      }

      return false;
    });

  const copyLinkRecordToBuffer = (linkRecord: LinkRecord) => {
    const link =
      linkRecord.links && linkRecord.links.length > 0
        ? linkRecord.links[0]
        : undefined;

    if (!link) {
      return;
    }

    navigator.clipboard.writeText(link.url).then(
      () => {
        toast("Copied!", toastSuccess);
      },
      (err) => {
        toast("Failed to copy!", toastFail);
      }
    );
  };

  const copyAllLinkRecordsToBuffer = (linkRecords: LinkRecord[]) => {
    let bufferText = "";

    linkRecords.forEach((linkRecord: LinkRecord) => {
      const link =
        linkRecord.links && linkRecord.links.length > 0
          ? linkRecord.links[0]
          : undefined;

      if (!link) {
        return;
      }

      bufferText += link.url + "\n";
    });

    navigator.clipboard.writeText(bufferText).then(
      () => {
        toast("Copied links!", toastSuccess);
      },
      (err) => {
        toast("Failed to copy links!", toastFail);
      }
    );
  };
  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // route it
    switch (selection) {
      case SNIPPET_MENU.DUPLICATE:
        onDuplicate();
        break;
      default:
    }
  };

  console.log("[SnippetSidebarMenu] snippet: ", snippet);
  console.log("[SnippetSidebarMenu] nonFileLinkRecords: ", nonFilelinkRecords);

  return (
    <>
      <div
        className="snippet-sidebar-menu-image-and-name"
        onClick={handleButtonClick}>
        <div className="snippet-sidebar-menu-caret">
          <img src="/icons/three_dots_vertical.png" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}>
        {snippet.id !== NEW_SNIPPET_ID && (
          <MenuItem onClick={() => handleMenuSelection(SNIPPET_MENU.DUPLICATE)}>
            Duplicate Quick Reply
          </MenuItem>
        )}
        {nonFilelinkRecords &&
          nonFilelinkRecords.length > 0 &&
          nonFilelinkRecords.map((linkRecord: LinkRecord) => {
            if (linkRecord.links && linkRecord.links.length > 0) {
              return (
                <MenuItem
                  onClick={() => {
                    copyLinkRecordToBuffer(linkRecord);
                    setAnchorEl(null);
                  }}>
                  Copy link for {linkRecord.links[0].title}
                </MenuItem>
              );
            }

            return null;
          })}
        {nonFilelinkRecords && nonFilelinkRecords.length > 1 && (
          <MenuItem
            onClick={() => {
              copyAllLinkRecordsToBuffer(nonFilelinkRecords);
              setAnchorEl(null);
            }}>
            Copy all Links
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
